import { formatISO } from 'date-fns'
import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { BFFComponent } from '@opallabs/api'

type KeyDate = BFFComponent<'key_date'>

export const keyDate: Factory<KeyDate> = Factory.define<KeyDate>(
  ({ sequence }) => {
    return {
      id: uuidV4(),
      title: `Mock Key Date ${sequence}`,
      color: null,
      start_date: formatISO(new Date()),
      end_date: null,
    } satisfies KeyDate
  }
)
